import Api from './Api';
import AppConfiguration from './AppConfiguration';

/**
 * This class represents a connection to the wtf api.
 * It has all the endpoints wrapped in methods that can be called directly.
 */
export default class WtfApi extends Api {
  constructor() {
    // Get all the configs.
    const config = AppConfiguration.getConfig();

    // Only use the wtf config for this Api subclass.
    super(config.api);
  }

  /**
   * Get the crop regions result styles for the cropped image.
   * @param {Object}    params The endpoint params.
   * @param {Object}    body   The body of the request to send.
   * @property {String} image  A base 64 encoded crop image.
   *
   * @example
   * body = {
   *   image: 'imageBase64',
   * }
   * @returns {Promise} The promise returned by the request.
   */
  getImageCropResults(params, body) {
    return Api.post(this.getEndpoint('results', params), body);
  }

  /**
   * Get the crop regions for the uploaded image.
   * @param {Object}    body  The body of the request to send.
   * @property {String} image A base 64 encoded image.
   *
   * @example
   * body = {
   *   image: 'imageBase64',
   * }
   * @returns {Promise} The promise returned by the request.
   */
  getImageCrops(body) {
    return Api.post(this.getEndpoint('autocrop'), body);
  }
}



// WEBPACK FOOTER //
// ./src/services/WtfApi.js